import { BehaviorSubject, Observable } from "rxjs";

export class ChangesDetection<T = Symbol> {
    private changesDetection: BehaviorSubject<T>;

    constructor() {
        this.changesDetection = new BehaviorSubject<T>(Symbol() as T);
    }

    forceUpdateDetection(value?: T): void {
        this.changesDetection.next(value !== undefined ? value : Symbol() as T);
    }

    getForcedChanges(): Observable<T> {
        return this.changesDetection.asObservable();
    }

    /** 
     * Crea una señal vinculada a la instancia. 
     * USO: Solo en constructores de componentes/servicios. 
     * NO USAR dentro de un computed().
     */
    // asSignal() {
    //     return toSignal(
    //         this.getForcedChanges().pipe(map(() => ({ instance: this }))),
    //         { initialValue: { instance: this } }
    //     );
    // }

}
